import type { QueryClient } from '@tanstack/react-query';

export const BANKING_DATA_QUERY_ROOTS = [
  'banking',
  'bank-account-identities',
  'finance',
  'integrations',
] as const;

/** Bank imports affect the feed, matched accounting accounts and Finance totals. */
export async function invalidateBankingData(client: QueryClient): Promise<void> {
  await Promise.all(
    BANKING_DATA_QUERY_ROOTS.map((root) => client.invalidateQueries({ queryKey: [root] })),
  );
}
